import styled from 'styled-components';

export const VideoStyle = styled.video`
    width: 100%;
`; 
